import React from "react";
import { Link } from "react-router-dom";
import { StyledButton } from "../../Common/Components";
import { PermissionNames } from "~enums/permissions";
import { ImageTypes } from "~enums/imageTypes";
import { ImageBaseTypes } from "~enums/imageBaseTypes";
import UploadImageListView from "../../components/Images/UploadImageListView.js";

export const getColumns = ({ formatMessage, customerId, sport }) => [
  {
    title: formatMessage({
      id: "name.local.full",
      defaultMessage: "Local Full Name",
    }),
    dataIndex: "nameFullLocal",
  },
  {
    title: formatMessage({
      id: "images.logo",
      defaultMessage: "Logo",
    }),
    render: (value, row) => (
      <UploadImageListView
        baseType={ImageBaseTypes.Entity}
        baseId={row.entityId}
        imageType={ImageTypes.Logo}
        images={row.images}
        permissionKey={PermissionNames.ENTITY}
      />
    ),
  },
  {
    title: formatMessage({
      id: "images.team.photo",
      defaultMessage: "Team photo",
    }),
    render: (value, row) => (
      <UploadImageListView
        baseType={ImageBaseTypes.Entity}
        baseId={row.entityId}
        imageType={ImageTypes.TeamPhoto}
        images={row.images}
        permissionKey={PermissionNames.ENTITY}
      />
    ),
  },
  {
    title: formatMessage({
      id: "images.background",
      defaultMessage: "Background",
    }),
    render: (value, row) => (
      <UploadImageListView
        baseType={ImageBaseTypes.Entity}
        baseId={row.entityId}
        imageType={ImageTypes.LogoBackground}
        images={row.images}
        permissionKey={PermissionNames.ENTITY}
      />
    ),
  },
  {
    render: (value, row) => (
      <>
        <StyledButton type="text">
          <Link to={`/${customerId}/admin/` + sport + "/" + row.organizationId + "/entities/manage/" + row.entityId}>
            {formatMessage({
              id: "details",
              defaultMessage: "Details",
            })}
          </Link>
        </StyledButton>
      </>
    ),
  },
];
